import HeaderMenu from 'components/navigation/menu/Header'
import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { dispatchHandler, useContextDispatch, useContextState } from 'services/context/MainContext'
import { actionTypes } from 'services/context/reducer'
import { getCookie, setCookie } from 'services/utils/CookieHandler'
import ScrollToTop from 'services/utils/ScrollToTop'
import { ApiUrls, urlAddTicketPage, urlAwardsPage, urlBarcodePage, urlChatPage, urlFirstPage, urlNoConnectionPage, urlNotifPage, urlSplashPage, urlSupportPage, urlTopsPage } from 'services/utils/globalVariables'
import { ProtectedRoute, UnProtectedRoute } from './ProtectedRoute'
import SplashPage from 'pages/SplashPage'
import AwardsPage from 'pages/AwardsPage'
import NotificationPage from 'pages/NotificationPage'
import BarcodePage from 'pages/BarcodePage'
import TopCustomerPage from 'pages/TopCustomerPage'
import SupportPage from 'pages/SupportPage'
import AddTicketPage from 'pages/AddTicketPage'
import ChatDetailPage from 'pages/ChatDetailPage'
import NotFoundPage from 'pages/NotFoundPage'
import BottomNavigationMenu from 'components/navigation/bottomNavigation/BottomNavigation'
import { HubConnectionBuilder } from '@microsoft/signalr';
import HomePage from 'pages/HomePage'

import NoConnectionPage from 'pages/NoConnectionPage'
import LoginService from 'services/utils/LoginService'
import GetExternalPrize from 'services/utils/GetExternalPrize'
import eruda from 'eruda'
import { Stack } from '@mui/material'

export default function MyRouter({ installer, setInstaller }) {

    const navigate = useNavigate()

    const [connection, setConnection] = useState(null)
    const [connection2, setConnection2] = useState(null)
    const [loader, setLoader] = useState()
    const [loadRoute, setLoadRoute] = useState(false)

    const loginInfo = getCookie("loginData")

    const location = useLocation()
    const dispatch = useContextDispatch()
    const { userInfo } = useContextState()
    const { GET_TICKETS } = actionTypes

    useEffect(() => {
        if(window.location.pathname != urlSplashPage) {
            setLoader(true)
        } else {
            setLoader(false)
        }
    }, [location])

    //adding new connection to signalR
    useEffect(() => {
        addNewConnection()
        //when user has qr prize code on params we will save it then reloading page
        if(window.location.href.includes("qr=")) {
            setCookie("prizeData", window.location.href)
            navigate("/")
        }
    }, [])

    useEffect(() => {
        handleConnectionHub()
    }, [connection, userInfo])


    useEffect(() => {
        if(userInfo.UserId == 43) {
            eruda.init()
        }
    }, [userInfo])


    //main logic of signalR connection
    const handleConnectionHub = () => {
        if(connection && loginInfo && Object.keys(userInfo).length) {
            connection.start().then((result) => {
                setConnection2(connection)
                connection.send("Join", connection.connectionId, +(loginInfo.userId), userInfo.IsAdmin, loginInfo.displayName)
                connection.on('GetTicketsList', res => {
                    connection.send('GetTicketsList', loginInfo.accessToken)
                })
                connection.send('GetTicketsList', loginInfo.accessToken)
                connection.on('TicketsList', res => {
                    dispatchHandler(dispatch, GET_TICKETS, {ticketList: res.data})
                })
                connection.on("RefreshList", res => {
                    dispatchHandler(dispatch, GET_TICKETS, {ticketList: res.data})
                })
            }).catch(e => {
                console.log('Connection failed: ', e)
            })
        }
    }

    //Adding a connection
    //For dev test uncomment the localhost and comment the server url
    const addNewConnection = () => {
        const newConnection = new HubConnectionBuilder()
        .withUrl('https://club.paksereshthome.com/hubs/ticket')
        // .withUrl('http://localhost:5005/hubs/ticket')
        .withAutomaticReconnect()
        .build()

        setConnection(newConnection)
    }

    return (
        <ScrollToTop>
            <LoginService>
                <GetExternalPrize>
                    {
                        loader &&
                        !location.pathname.includes("chatid") &&
                        !location.pathname.includes("support/add") &&
                        !location.pathname.includes("no-connection") &&

                        <HeaderMenu installer={installer} setInstaller={setInstaller} loading={true} />
                    }
                    <Stack sx={{width: {lg: "400px !important", margin: "0 auto"}}}>
                        <Routes>
                            <Route children="/*" element={<UnProtectedRoute />}>
                                <Route path={urlSplashPage} index element={<SplashPage />} />
                            </Route>
                            <Route children="/*" element={<ProtectedRoute />}>
                                <Route path={urlFirstPage} index element={<HomePage />} />
                                <Route path={urlAwardsPage} element={<AwardsPage />} />
                                <Route path={urlNotifPage} element={<NotificationPage />} />
                                <Route path={urlBarcodePage} element={<BarcodePage />} />
                                <Route path={urlTopsPage} element={<TopCustomerPage />} />
                                <Route path={urlSupportPage} element={<SupportPage />} />
                                <Route path={urlAddTicketPage} element={<AddTicketPage connection={connection2} />} />
                                <Route path={urlChatPage + "/:chatId"} element={<ChatDetailPage connection={connection2} />} />
                            </Route>
                            <Route path={urlNoConnectionPage} element={<NoConnectionPage />} />
                            <Route path="/*" element={<NotFoundPage />} />
                        </Routes>
                    </Stack>

                    {
                        loader &&
                        !location.pathname.includes("chatid") &&
                        !location.pathname.includes("no-connection") &&
                        <BottomNavigationMenu />
                    }
                </GetExternalPrize>
            </LoginService>
        </ScrollToTop>
    );
}